import { styled } from "styled-components";
import { colors } from "constants/colors";
import { StyledText10 } from "styles/Text";

const InfoMark = () => {
  return (
    <StyledContainer>
      <StyledText10 fontWeight="700" color={colors.white}>
        !
      </StyledText10>
    </StyledContainer>
  );
};

export default InfoMark;

const StyledContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: 12px;
  height: 12px;
  background-color: ${colors.mainOrange};
  text-align: center;
`;
